// Trip edits from the organiser screens: each is an event (shared/trip.ts) recorded locally and
// synced; the projection (domain/trip) shows it straight away, online or not.
import { ulid } from 'ulid'
import type { Place } from '../../shared/pack/schema'
import type { TripItemFields } from '../../shared/trip'
import { record } from '../data/events'

export const newItemId = () => `i-${ulid().toLowerCase()}`

/** A readable, unique place id from its name ("Yukoro Onsen" → "yukoro-onsen-4k2p"). */
export function newPlaceId(name: string): string {
  const slug = name.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 24)
  return `${slug || 'place'}-${ulid().slice(-4).toLowerCase()}`
}

export function setItem(tripId: string, itemId: string, fields: TripItemFields, by: string) {
  return record('trip.item.set', { tripId, itemId, fields }, by)
}

export function removeItem(tripId: string, itemId: string, by: string) {
  return record('trip.item.removed', { tripId, itemId }, by)
}

export function addPlace(tripId: string, placeId: string, fields: Omit<Place, 'id'>, by: string) {
  return record('trip.place.set', { tripId, placeId, fields }, by)
}
